import React, { useState } from 'react'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/Card'
import { Link, useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { useDispatch } from 'react-redux'
import { login } from '@/store/actions/auth/login'
import Logo from "@/assets/images/Vite_Black_Remove_Bg.png";
import { Eye, EyeOff } from 'lucide-react'

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [error, setError] = useState({});
  const [userInfo, setUserInfo] = useState({
    email: '',
    password: '',
  });
  
  const [passwordVisible, setPasswordVisible] = useState(false); // Add this state

  const handleChange = (e) => {
    setUserInfo({ ...userInfo, [e.target.name]: e.target.value })
  };

  const handleValidation = () => {
    let errors = {};
    let isValid = true;
    if (userInfo.email === '') {
      errors['email'] = 'Please enter your email';
      isValid = false;
    }
    if (userInfo.password === '') {
      errors['password'] = 'Please enter a password';
      isValid = false;
    }

    setError(errors);
    return isValid;
  };

  const handleSubmit = (e) => {
    if (handleValidation()) {
      dispatch(login(userInfo, navigate))
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  return (
    <div className='flex justify-center items-center  h-screen p-4'>
      <Card className="max-w-2xl w-full relative" >
        <div className='flex justify-center items-center pt-4'>
          <img className='absolute -top-12 left-[50%] -translate-x-1/2 w-[6rem] h-[2rem]' src={Logo} alt="logo image" quality={100} loading='lazy' />
        </div>
        <CardHeader>
          <CardTitle className="text-2xl font-500">Sign in</CardTitle>
          <CardDescription>
            Provider your  Credentials We Keep It Safe.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-2">
          <div className="space-y-1">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" name="email" placeholder="johnDoe@gmail.com" onChange={(e) => handleChange(e)} onKeyPress={handleKeyPress} autoComplete='off' />
            <div className={error['email'] ? "text-rose-600" : ''}>{error['email'] ? error['email'] : null}</div>
          </div>
          <div className="space-y-1 relative">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type={passwordVisible ? 'text' : 'password'} name="password" placeholder="********" onChange={handleChange} onKeyPress={handleKeyPress} autoComplete='off' />
            <Button className="w-12 bg-transparent order-last py-2 px-0  hover:!bg-transparent border-s absolute right-0 top-[1.6rem] rounded-ss-none rounded-es-none" onClick={togglePasswordVisibility}>
              {passwordVisible ? <EyeOff className='text-black' /> : <Eye className='text-black' />}
            </Button>
            <div className={error['password'] ? "text-rose-600" : ''}>{error['password'] ? error['password'] : null}</div>
          </div>
        </CardContent>
        <CardFooter className="sm:flex items-center justify-between block space-y-2">
          <Button className="order-last  " onClick={handleSubmit}>Login</Button>
          <Link to="/signup" className='text-[13px]  order-1 sm:order-3 '>Don’t have an account? <span className="text-sm font-semibold hover:underline text-gray-700">Sign Up Now</span></Link>
        </CardFooter>

      </Card>
    </div>
  )
}

export default Login